// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для анкеты и регистрации */
.anketa-container {
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    padding: 2rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
    box-sizing: border-box;
    overflow-x: hidden;
}

/* Карточка */
.anketa-card,
.register-card {
    background: var(--bg-card);
    border-radius: 16px;
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    border-top: 2px solid var(--border-subtle);
    margin-bottom: 2rem;
    transition: box-shadow 0.25s ease, border-color 0.2s;
}

.anketa-card:hover,
.register-card:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
}

/* Прогресс бар */
.progress-section {
    margin-bottom: 2rem;
}

.progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
}

.progress-text {
    color: var(--text-secondary);
    font-size: 0.9rem;
}

.progress-percentage {
    color: var(--accent);
    font-weight: 600;
    font-size: 0.9rem;
}

.progress-bar {
    width: 100%;
    height: 10px;
    background: var(--input-bg);
    border-radius: 6px;
    overflow: hidden;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

.progress-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--accent) 0%, var(--accent-light) 100%);
    border-radius: 6px;
    transition: width 0.5s ease;
    box-shadow: 0 0 12px var(--accent-glow);
}

/* Секция с вопросом */
.question-section {
    text-align: center;
    margin-bottom: 2.5rem;
}

.question-number-display {
    margin-bottom: 1rem;
}

.current-question {
    font-size: 3rem;
    font-weight: 700;
    color: var(--accent);
}

.total-questions {
    font-size: 1.5rem;
    color: var(--text-muted);
}

.question-text {
    color: var(--text-primary);
    font-size: 1.5rem;
    line-height: 1.4;
    margin: 1rem 0;
}

.question-hint {
    color: var(--text-secondary);
    font-size: 0.9rem;
}

/* Варианты ответов */
.answers-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 2rem;
}

.answer-btn {
    padding: 2rem 1rem;
    border: 2px solid var(--border-color);
    border-radius: 12px;
    background: var(--bg-card);
    cursor: pointer;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 140px;
}

.answer-btn:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-card);
}

.yes-btn {
    border-color: rgba(16, 185, 129, 0.4);
}

.yes-btn:hover {
    border-color: #10b981;
    box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
}

.no-btn {
    border-color: rgba(239, 68, 68, 0.35);
}

.no-btn:hover {
    border-color: #ef4444;
    box-shadow: 0 4px 20px rgba(239, 68, 68, 0.15);
}

.answer-text {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
}

.yes-btn .answer-text {
    color: #10b981;
}

.no-btn .answer-text {
    color: #ef4444;
}

/* Навигация */
.navigation-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-color);
}

.nav-btn {
    padding: 0.75rem 1.5rem;
    border: 1px solid var(--border-color);
    background: var(--bg-secondary);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    cursor: pointer;
    font-size: 0.95rem;
    font-family: var(--font);
    transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
}

.nav-btn:hover:not(:disabled) {
    background: var(--input-bg);
}

.nav-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.prev-btn {
    border-color: var(--accent);
    color: var(--accent);
}

.next-btn,
.submit-btn {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    border: none;
    box-shadow: 0 2px 10px var(--accent-glow);
}

.next-btn:hover:not(:disabled),
.submit-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px var(--accent-glow);
}

.home-btn {
    border-color: var(--text-muted);
    color: var(--text-secondary);
}

.completion-info {
    color: var(--text-secondary);
    font-size: 0.9rem;
}

/* Индикатор текущего ответа */
.current-answer-indicator {
    background: var(--success-bg);
    border: 1px solid var(--accent);
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    color: var(--accent);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 1rem;
}

.current-answer {
    font-weight: 700;
    margin: 0 0.5rem;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
}

.current-answer.yes {
    background: #10b981;
    color: white;
}

.current-answer.no {
    background: #ef4444;
    color: white;
}

.change-answer-btn {
    background: none;
    border: 1px solid var(--accent);
    color: var(--accent);
    padding: 0.25rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
}

/* Поле для ввода сообщений (обратная связь) */
.textarea-input {
    width: 100%;
    min-height: 140px;
    resize: vertical;
    border-radius: 10px;
    border: 1px solid var(--border-color);
    padding: 0.75rem 0.9rem;
    background: var(--input-bg);
    color: var(--text-primary);
    font-family: inherit;
    font-size: 0.95rem;
    line-height: 1.5;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.textarea-input::placeholder {
    color: var(--text-muted);
}

.textarea-input:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);
    background: var(--bg-card-hover);
}

/* Карточка завершения */
.completion-card {
    background: var(--bg-card);
    border-radius: 16px;
    padding: 3rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    border-top: 2px solid var(--border-subtle);
    text-align: center;
}

.error-title {
    color: var(--error);
    margin-bottom: 1rem;
}

.success-title {
    color: var(--success);
}

/* Стили для регистрации */
.date-input-section {
    text-align: center;
    margin-bottom: 2rem;
}

.date-input {
    padding: 1rem;
    border: 2px solid var(--input-border);
    border-radius: 8px;
    font-size: 1rem;
    width: 100%;
    max-width: 300px;
    transition: border-color 0.3s;
    background: var(--input-bg);
    color: var(--text-primary);
}

.date-input:focus {
    outline: none;
    border-color: var(--accent);
}

.date-hint {
    color: var(--text-muted);
    font-size: 0.9rem;
    margin-top: 0.5rem;
}

.revenue-date-picker {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
}

.revenue-date-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: center;
    gap: 0.75rem 1rem;
}

.revenue-date-field {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 0;
    flex: 1 1 100px;
}

.revenue-date-field-year {
    flex: 0 0 auto;
    min-width: 4.5rem;
}

.revenue-date-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--text-secondary);
    margin-bottom: 0.35rem;
    text-align: left;
}

.revenue-date-select {
    padding: 0.75rem 0.6rem;
    border: 2px solid var(--input-border);
    border-radius: 8px;
    font-size: 1rem;
    width: 100%;
    min-height: 2.75rem;
    box-sizing: border-box;
    background: var(--input-bg);
    color: var(--text-primary);
    cursor: pointer;
    transition: border-color 0.3s;
}

.revenue-date-select:focus {
    outline: none;
    border-color: var(--accent);
}

.revenue-date-unavailable {
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.45;
    max-width: 420px;
    margin: 0 auto 0.5rem;
    text-align: center;
}

.revenue-year-fixed {
    padding: 0.75rem 1rem;
    border: 2px solid var(--border-subtle);
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    background: var(--input-bg);
    color: var(--text-primary);
    min-height: 2.75rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Форма данных регистрации */
.form-section {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 2rem;
}

.form-group {
    margin-bottom: 1rem;
}

.form-group label {
    display: block;
    color: var(--text-secondary);
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-size: 0.9rem;
}

.form-group input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--input-border);
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    box-sizing: border-box;
    background: var(--input-bg);
    color: var(--text-primary);
}

.form-group input:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-glow);
}

.form-group .field-error,
.agreement-item .field-error {
    color: var(--error);
    font-size: 0.85rem;
    margin-top: 0.35rem;
}

.password-input-wrapper {
    position: relative;
}

.password-toggle-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--text-secondary);
    cursor: pointer;
    padding: 4px 8px;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
}

.password-toggle-btn:hover {
    color: var(--accent);
}

.form-group input[type="password"],
.form-group input[type="text"] {
    padding-right: 45px;
}

/* Соглашения */
.agreements-section {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-color);
}

.agreement-item {
    margin-bottom: 1rem;
}

.agreement-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding-left: 2rem;
}

.agreement-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkmark {
    position: absolute;
    left: 0;
    top: 0;
    height: 20px;
    width: 20px;
    background-color: var(--input-bg);
    border: 2px solid var(--input-border);
    border-radius: 4px;
}

.agreement-checkbox input:checked ~ .checkmark {
    background-color: var(--accent);
    border-color: var(--accent);
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.agreement-checkbox input:checked ~ .checkmark:after {
    display: block;
}

.agreement-text {
    color: var(--text-secondary);
    font-size: 0.95rem;
}

.agreement-link {
    color: var(--accent);
    text-decoration: none;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    cursor: pointer;
    display: inline;
}

.agreement-link:hover {
    text-decoration: underline;
}

/* Сообщения */
.error-message {
    background: var(--error-bg);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 1.5rem 0;
    border: 1px solid var(--error);
}

.success-message {
    background: var(--success-bg);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 1.5rem 0;
    border: 1px solid var(--success);
}

.success-message h4 {
    color: var(--success);
    margin-bottom: 0.5rem;
}

.success-message p,
.error-message p {
    color: var(--text-secondary);
}

/* Действия */
.completion-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin: 2rem 0;
}

.action-btn {
    padding: 1rem 2rem;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
}

.reset-btn {
    background: var(--accent);
    color: white;
}

.reset-btn:hover {
    background: var(--accent-hover);
    transform: translateY(-2px);
}

/* Футер для регистрации */
.register-footer {
    text-align: center;
    margin-top: 2rem;
    color: var(--text-secondary);
    font-size: 0.95rem;
}

.login-link {
    color: var(--accent);
    text-decoration: none;
    font-weight: 600;
}

.login-link:hover {
    text-decoration: underline;
}

/* Адаптивность */
@media (max-width: 768px) {
    .anketa-container {
        padding: 1rem;
    }

    .anketa-card,
    .register-card {
        padding: 1.5rem;
    }

    .answers-section {
        grid-template-columns: 1fr;
    }

    .question-text {
        font-size: 1.25rem;
    }

    .answer-text {
        font-size: 1.5rem;
    }

    .answer-btn {
        min-height: 100px;
    }

    .navigation-section {
        flex-direction: column;
        gap: 1rem;
    }

    .nav-btn {
        width: 100%;
        text-align: center;
    }

    .completion-info {
        order: -1;
    }

    .completion-card {
        padding: 1.5rem;
    }

    .completion-actions {
        flex-direction: column;
    }

    .form-section {
        grid-template-columns: 1fr;
    }
}

/* Телефон */
@media (max-width: 480px) {
    .anketa-container {
        padding: 1rem;
    }

    .anketa-card,
    .register-card {
        padding: 1rem;
        border-radius: 12px;
        margin-bottom: 1rem;
    }

    .current-question {
        font-size: 2rem;
    }

    .total-questions {
        font-size: 1.2rem;
    }

    .question-text {
        font-size: 1.1rem;
        margin: 0.75rem 0;
    }

    .question-hint {
        font-size: 0.85rem;
    }

    .answers-section {
        gap: 0.75rem;
        margin-bottom: 1.5rem;
    }

    .answer-btn {
        min-height: 80px;
        padding: 1rem 0.75rem;
    }

    .answer-text {
        font-size: 1.35rem;
    }

    .navigation-section {
        margin-top: 1.5rem;
        padding-top: 0.75rem;
        gap: 0.75rem;
    }

    .nav-btn {
        padding: 0.65rem 1rem;
        font-size: 0.9rem;
        min-height: 44px;
    }

    .date-input {
        max-width: 100%;
        padding: 0.85rem;
        font-size: 1rem;
    }

    .revenue-date-select {
        font-size: 16px;
    }

    .form-group input {
        padding: 0.85rem;
        font-size: 16px; /* уменьшает зум на iOS при фокусе */
    }

    .completion-card {
        padding: 1.5rem 1rem;
    }

    .completion-actions .action-btn {
        padding: 0.85rem 1.25rem;
        min-height: 44px;
    }
}

/* Дополнительные стили для переиспользуемого компонента */
.questionnaire-header {
    text-align: center;
    margin-bottom: 1.5rem;
}

.questionnaire-title {
    color: var(--accent);
    font-size: 1.8rem;
    margin: 0;
}

.answer-badge.neutral {
    background: var(--input-bg);
    color: var(--text-secondary);
}

.home-btn {
    background: var(--text-muted);
    color: white;
    border: none;
}

.home-btn:hover {
    background: var(--text-secondary);
}

/* Анимация прогресса */
@keyframes progressPulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.02); }
    100% { transform: scale(1); }
}

.progress-fill {
    animation: progressPulse 2s infinite;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Anketa.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,aAAa;IACb,8FAA8F;IAC9F,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,aAAa;AACb;;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,8EAA8E;IAC9E,kBAAkB;IAClB,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,0EAA0E;IAC1E,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,+BAA+B;IAC/B,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;;IAEI,+EAA+E;IAC/E,YAAY;IACZ,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;;IAEI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,+DAA+D;AACnE;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,6CAA6C;IAC7C,gCAAgC;AACpC;;AAEA,wBAAwB;AACxB;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,cAAc;AACd;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,aAAa;AACb;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe,EAAE,oCAAoC;IACzD;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;;AAEA,0DAA0D;AAC1D;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,uBAAuB;AACvB;IACI,KAAK,mBAAmB,EAAE;IAC1B,MAAM,sBAAsB,EAAE;IAC9B,OAAO,mBAAmB,EAAE;AAChC;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["/* Общие стили для анкеты и регистрации */\n.anketa-container {\n    max-width: 800px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 2rem;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n    box-sizing: border-box;\n    overflow-x: hidden;\n}\n\n/* Карточка */\n.anketa-card,\n.register-card {\n    background: var(--bg-card);\n    border-radius: 16px;\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    border-top: 2px solid var(--border-subtle);\n    margin-bottom: 2rem;\n    transition: box-shadow 0.25s ease, border-color 0.2s;\n}\n\n.anketa-card:hover,\n.register-card:hover {\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);\n}\n\n/* Прогресс бар */\n.progress-section {\n    margin-bottom: 2rem;\n}\n\n.progress-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.5rem;\n}\n\n.progress-text {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n}\n\n.progress-percentage {\n    color: var(--accent);\n    font-weight: 600;\n    font-size: 0.9rem;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 10px;\n    background: var(--input-bg);\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.progress-fill {\n    height: 100%;\n    background: linear-gradient(90deg, var(--accent) 0%, var(--accent-light) 100%);\n    border-radius: 6px;\n    transition: width 0.5s ease;\n    box-shadow: 0 0 12px var(--accent-glow);\n}\n\n/* Секция с вопросом */\n.question-section {\n    text-align: center;\n    margin-bottom: 2.5rem;\n}\n\n.question-number-display {\n    margin-bottom: 1rem;\n}\n\n.current-question {\n    font-size: 3rem;\n    font-weight: 700;\n    color: var(--accent);\n}\n\n.total-questions {\n    font-size: 1.5rem;\n    color: var(--text-muted);\n}\n\n.question-text {\n    color: var(--text-primary);\n    font-size: 1.5rem;\n    line-height: 1.4;\n    margin: 1rem 0;\n}\n\n.question-hint {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n}\n\n/* Варианты ответов */\n.answers-section {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.answer-btn {\n    padding: 2rem 1rem;\n    border: 2px solid var(--border-color);\n    border-radius: 12px;\n    background: var(--bg-card);\n    cursor: pointer;\n    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.2s;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 140px;\n}\n\n.answer-btn:hover {\n    transform: translateY(-3px);\n    box-shadow: var(--shadow-card);\n}\n\n.yes-btn {\n    border-color: rgba(16, 185, 129, 0.4);\n}\n\n.yes-btn:hover {\n    border-color: #10b981;\n    box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);\n}\n\n.no-btn {\n    border-color: rgba(239, 68, 68, 0.35);\n}\n\n.no-btn:hover {\n    border-color: #ef4444;\n    box-shadow: 0 4px 20px rgba(239, 68, 68, 0.15);\n}\n\n.answer-text {\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 0.25rem;\n}\n\n.yes-btn .answer-text {\n    color: #10b981;\n}\n\n.no-btn .answer-text {\n    color: #ef4444;\n}\n\n/* Навигация */\n.navigation-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.nav-btn {\n    padding: 0.75rem 1.5rem;\n    border: 1px solid var(--border-color);\n    background: var(--bg-secondary);\n    border-radius: var(--radius-sm);\n    color: var(--text-primary);\n    cursor: pointer;\n    font-size: 0.95rem;\n    font-family: var(--font);\n    transition: background 0.2s, transform 0.2s, box-shadow 0.2s;\n}\n\n.nav-btn:hover:not(:disabled) {\n    background: var(--input-bg);\n}\n\n.nav-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.prev-btn {\n    border-color: var(--accent);\n    color: var(--accent);\n}\n\n.next-btn,\n.submit-btn {\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n    color: white;\n    border: none;\n    box-shadow: 0 2px 10px var(--accent-glow);\n}\n\n.next-btn:hover:not(:disabled),\n.submit-btn:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px var(--accent-glow);\n}\n\n.home-btn {\n    border-color: var(--text-muted);\n    color: var(--text-secondary);\n}\n\n.completion-info {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n}\n\n/* Индикатор текущего ответа */\n.current-answer-indicator {\n    background: var(--success-bg);\n    border: 1px solid var(--accent);\n    border-radius: 8px;\n    padding: 1rem;\n    text-align: center;\n    color: var(--accent);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-top: 1rem;\n}\n\n.current-answer {\n    font-weight: 700;\n    margin: 0 0.5rem;\n    padding: 0.25rem 0.75rem;\n    border-radius: 20px;\n}\n\n.current-answer.yes {\n    background: #10b981;\n    color: white;\n}\n\n.current-answer.no {\n    background: #ef4444;\n    color: white;\n}\n\n.change-answer-btn {\n    background: none;\n    border: 1px solid var(--accent);\n    color: var(--accent);\n    padding: 0.25rem 0.75rem;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n/* Поле для ввода сообщений (обратная связь) */\n.textarea-input {\n    width: 100%;\n    min-height: 140px;\n    resize: vertical;\n    border-radius: 10px;\n    border: 1px solid var(--border-color);\n    padding: 0.75rem 0.9rem;\n    background: var(--input-bg);\n    color: var(--text-primary);\n    font-family: inherit;\n    font-size: 0.95rem;\n    line-height: 1.5;\n    box-sizing: border-box;\n    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n.textarea-input::placeholder {\n    color: var(--text-muted);\n}\n\n.textarea-input:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);\n    background: var(--bg-card-hover);\n}\n\n/* Карточка завершения */\n.completion-card {\n    background: var(--bg-card);\n    border-radius: 16px;\n    padding: 3rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    border-top: 2px solid var(--border-subtle);\n    text-align: center;\n}\n\n.error-title {\n    color: var(--error);\n    margin-bottom: 1rem;\n}\n\n.success-title {\n    color: var(--success);\n}\n\n/* Стили для регистрации */\n.date-input-section {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.date-input {\n    padding: 1rem;\n    border: 2px solid var(--input-border);\n    border-radius: 8px;\n    font-size: 1rem;\n    width: 100%;\n    max-width: 300px;\n    transition: border-color 0.3s;\n    background: var(--input-bg);\n    color: var(--text-primary);\n}\n\n.date-input:focus {\n    outline: none;\n    border-color: var(--accent);\n}\n\n.date-hint {\n    color: var(--text-muted);\n    font-size: 0.9rem;\n    margin-top: 0.5rem;\n}\n\n.revenue-date-picker {\n    width: 100%;\n    max-width: 420px;\n    margin: 0 auto;\n}\n\n.revenue-date-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    justify-content: center;\n    gap: 0.75rem 1rem;\n}\n\n.revenue-date-field {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 0;\n    flex: 1 1 100px;\n}\n\n.revenue-date-field-year {\n    flex: 0 0 auto;\n    min-width: 4.5rem;\n}\n\n.revenue-date-label {\n    display: block;\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    margin-bottom: 0.35rem;\n    text-align: left;\n}\n\n.revenue-date-select {\n    padding: 0.75rem 0.6rem;\n    border: 2px solid var(--input-border);\n    border-radius: 8px;\n    font-size: 1rem;\n    width: 100%;\n    min-height: 2.75rem;\n    box-sizing: border-box;\n    background: var(--input-bg);\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: border-color 0.3s;\n}\n\n.revenue-date-select:focus {\n    outline: none;\n    border-color: var(--accent);\n}\n\n.revenue-date-unavailable {\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n    line-height: 1.45;\n    max-width: 420px;\n    margin: 0 auto 0.5rem;\n    text-align: center;\n}\n\n.revenue-year-fixed {\n    padding: 0.75rem 1rem;\n    border: 2px solid var(--border-subtle);\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    background: var(--input-bg);\n    color: var(--text-primary);\n    min-height: 2.75rem;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Форма данных регистрации */\n.form-section {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n\n.form-group label {\n    display: block;\n    color: var(--text-secondary);\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    font-size: 0.9rem;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid var(--input-border);\n    border-radius: 6px;\n    font-size: 1rem;\n    transition: all 0.3s;\n    box-sizing: border-box;\n    background: var(--input-bg);\n    color: var(--text-primary);\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px var(--accent-glow);\n}\n\n.form-group .field-error,\n.agreement-item .field-error {\n    color: var(--error);\n    font-size: 0.85rem;\n    margin-top: 0.35rem;\n}\n\n.password-input-wrapper {\n    position: relative;\n}\n\n.password-toggle-btn {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: var(--text-secondary);\n    cursor: pointer;\n    padding: 4px 8px;\n    font-size: 1.1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s;\n}\n\n.password-toggle-btn:hover {\n    color: var(--accent);\n}\n\n.form-group input[type=\"password\"],\n.form-group input[type=\"text\"] {\n    padding-right: 45px;\n}\n\n/* Соглашения */\n.agreements-section {\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.agreement-item {\n    margin-bottom: 1rem;\n}\n\n.agreement-checkbox {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    padding-left: 2rem;\n}\n\n.agreement-checkbox input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.checkmark {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 20px;\n    width: 20px;\n    background-color: var(--input-bg);\n    border: 2px solid var(--input-border);\n    border-radius: 4px;\n}\n\n.agreement-checkbox input:checked ~ .checkmark {\n    background-color: var(--accent);\n    border-color: var(--accent);\n}\n\n.checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n    left: 6px;\n    top: 2px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.agreement-checkbox input:checked ~ .checkmark:after {\n    display: block;\n}\n\n.agreement-text {\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n}\n\n.agreement-link {\n    color: var(--accent);\n    text-decoration: none;\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font: inherit;\n    cursor: pointer;\n    display: inline;\n}\n\n.agreement-link:hover {\n    text-decoration: underline;\n}\n\n/* Сообщения */\n.error-message {\n    background: var(--error-bg);\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin: 1.5rem 0;\n    border: 1px solid var(--error);\n}\n\n.success-message {\n    background: var(--success-bg);\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin: 1.5rem 0;\n    border: 1px solid var(--success);\n}\n\n.success-message h4 {\n    color: var(--success);\n    margin-bottom: 0.5rem;\n}\n\n.success-message p,\n.error-message p {\n    color: var(--text-secondary);\n}\n\n/* Действия */\n.completion-actions {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    margin: 2rem 0;\n}\n\n.action-btn {\n    padding: 1rem 2rem;\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\n.reset-btn {\n    background: var(--accent);\n    color: white;\n}\n\n.reset-btn:hover {\n    background: var(--accent-hover);\n    transform: translateY(-2px);\n}\n\n/* Футер для регистрации */\n.register-footer {\n    text-align: center;\n    margin-top: 2rem;\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n}\n\n.login-link {\n    color: var(--accent);\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.login-link:hover {\n    text-decoration: underline;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n    .anketa-container {\n        padding: 1rem;\n    }\n\n    .anketa-card,\n    .register-card {\n        padding: 1.5rem;\n    }\n\n    .answers-section {\n        grid-template-columns: 1fr;\n    }\n\n    .question-text {\n        font-size: 1.25rem;\n    }\n\n    .answer-text {\n        font-size: 1.5rem;\n    }\n\n    .answer-btn {\n        min-height: 100px;\n    }\n\n    .navigation-section {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .nav-btn {\n        width: 100%;\n        text-align: center;\n    }\n\n    .completion-info {\n        order: -1;\n    }\n\n    .completion-card {\n        padding: 1.5rem;\n    }\n\n    .completion-actions {\n        flex-direction: column;\n    }\n\n    .form-section {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Телефон */\n@media (max-width: 480px) {\n    .anketa-container {\n        padding: 1rem;\n    }\n\n    .anketa-card,\n    .register-card {\n        padding: 1rem;\n        border-radius: 12px;\n        margin-bottom: 1rem;\n    }\n\n    .current-question {\n        font-size: 2rem;\n    }\n\n    .total-questions {\n        font-size: 1.2rem;\n    }\n\n    .question-text {\n        font-size: 1.1rem;\n        margin: 0.75rem 0;\n    }\n\n    .question-hint {\n        font-size: 0.85rem;\n    }\n\n    .answers-section {\n        gap: 0.75rem;\n        margin-bottom: 1.5rem;\n    }\n\n    .answer-btn {\n        min-height: 80px;\n        padding: 1rem 0.75rem;\n    }\n\n    .answer-text {\n        font-size: 1.35rem;\n    }\n\n    .navigation-section {\n        margin-top: 1.5rem;\n        padding-top: 0.75rem;\n        gap: 0.75rem;\n    }\n\n    .nav-btn {\n        padding: 0.65rem 1rem;\n        font-size: 0.9rem;\n        min-height: 44px;\n    }\n\n    .date-input {\n        max-width: 100%;\n        padding: 0.85rem;\n        font-size: 1rem;\n    }\n\n    .revenue-date-select {\n        font-size: 16px;\n    }\n\n    .form-group input {\n        padding: 0.85rem;\n        font-size: 16px; /* уменьшает зум на iOS при фокусе */\n    }\n\n    .completion-card {\n        padding: 1.5rem 1rem;\n    }\n\n    .completion-actions .action-btn {\n        padding: 0.85rem 1.25rem;\n        min-height: 44px;\n    }\n}\n\n/* Дополнительные стили для переиспользуемого компонента */\n.questionnaire-header {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.questionnaire-title {\n    color: var(--accent);\n    font-size: 1.8rem;\n    margin: 0;\n}\n\n.answer-badge.neutral {\n    background: var(--input-bg);\n    color: var(--text-secondary);\n}\n\n.home-btn {\n    background: var(--text-muted);\n    color: white;\n    border: none;\n}\n\n.home-btn:hover {\n    background: var(--text-secondary);\n}\n\n/* Анимация прогресса */\n@keyframes progressPulse {\n    0% { transform: scale(1); }\n    50% { transform: scale(1.02); }\n    100% { transform: scale(1); }\n}\n\n.progress-fill {\n    animation: progressPulse 2s infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
